//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular, {IDocumentService} from 'angular';

export default class ClipboardService {

  constructor(
        private $document: IDocumentService,
    ) {}

  public copyString(elementContext, stringToCopy) {
    const clipText = this.$document[0].createElement('textarea');
    clipText.value = stringToCopy;

        // Only copy if clipText.value isn't empty (data-clipboard-text has been initialized)
    if (clipText.value) {
            // The textbox must be prepended or else it will cause the page to jump scroll down slightly
      elementContext.context.appendChild(clipText);

            // FF and Chrome require a focused editable field
      clipText.focus();

            // IE and safari require the text to be selected
      clipText.setSelectionRange(0, clipText.value.length);

      this.$document[0].execCommand('copy');

            // Remove the textbox
      elementContext.context.removeChild(clipText);

      return true;
    } else {
      return false;
    }
  }
}

angular.module('curalate').service('ClipboardService', [
  '$document',
  ClipboardService,
]);
